import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import { useT } from '../i18n/useT';

const BackToOverview: React.FC = () => {
  const { r } = useT();
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.2 });
  const card = r.routes.fullPlatformCard;

  return (
    <Box
      component="section"
      sx={{
        py: { xs: 6, md: 8 },
        backgroundColor: '#F8FAFC',
      }}
    >
      <Container maxWidth="md">
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
          transition={{ duration: 0.6 }}
        >
          <Box
            sx={{
              p: { xs: 3, md: 5 },
              borderRadius: 3,
              backgroundColor: 'white',
              border: '1px solid #E2E8F0',
              boxShadow: '0 1px 2px rgba(15, 23, 42, 0.04)',
              display: 'flex',
              flexDirection: { xs: 'column', md: 'row' },
              alignItems: { xs: 'flex-start', md: 'center' },
              justifyContent: 'space-between',
              gap: 3,
            }}
          >
            <Box>
              <Typography
                component="span"
                sx={{
                  color: '#64748B',
                  fontWeight: 700,
                  fontSize: '0.75rem',
                  letterSpacing: '0.12em',
                  textTransform: 'uppercase',
                  fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
                  display: 'block',
                  mb: 1,
                }}
              >
                {card.eyebrow}
              </Typography>
              <Typography
                component="p"
                sx={{
                  fontWeight: 700,
                  color: '#0F172A',
                  fontSize: { xs: '1.15rem', md: '1.35rem' },
                  mb: 0.5,
                  letterSpacing: '-0.01em',
                }}
              >
                {card.title}
              </Typography>
              <Typography sx={{ color: '#475569', fontSize: { xs: '0.95rem', md: '1rem' }, lineHeight: 1.55 }}>
                {card.description}
              </Typography>
            </Box>
            <Button
              component={RouterLink}
              to="/"
              endIcon={<ArrowForwardRoundedIcon />}
              sx={{
                flexShrink: 0,
                px: 3.5,
                py: 1.3,
                borderRadius: '50px',
                backgroundColor: '#0F172A',
                color: 'white',
                fontWeight: 700,
                fontSize: '0.95rem',
                textTransform: 'none',
                '&:hover': {
                  backgroundColor: '#1E293B',
                  transform: 'translateY(-2px)',
                },
              }}
            >
              {card.cta}
            </Button>
          </Box>
        </motion.div>
      </Container>
    </Box>
  );
};

export default BackToOverview;
